import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import {
  camera,
  loadFaceDetectorModels,
  faceDetectionAdapter,
} from "@biopassid/face-sdk";
import { HttpClient } from "@angular/common/http";
import { catchError, take } from "rxjs/operators";
import { ThemeService } from "src/app/services/theme.service";
import { Options } from "@biopassid/face-sdk/types";
import { tenantAssetsBase } from "src/app/utils/tenant-from-host";

@Component({
  selector: "app-image-capture-vsoft",
  templateUrl: "./image-capture-vsoft.component.html",
  styleUrls: ["./image-capture-vsoft.component.scss"],
})
export class ImageCaptureVsoftComponent implements AfterViewInit {
  @Output()
  imageCapture = new EventEmitter<{ image: string; appKey: string }>();

  @Output()
  cancel = new EventEmitter();

  @Output()
  captureError = new EventEmitter<string>();

  vsoftOptions: any = null;

  constructor(
    private httpClient: HttpClient,
    private themeService: ThemeService
  ) {}

  async ngAfterViewInit(): Promise<void> {
    const emissor = this.themeService.getThemeFromUrl();
    this.loadVsoftConfigFile(emissor).subscribe((loadedOptions) => {
      try {
        const vsoftOptions = JSON.parse(loadedOptions);
        this.prepareCamera(vsoftOptions);
      } catch (error) {
        console.log(error);
        this.captureError.emit(
          "Algo errado ocorreu ao tentar carregar as configuracoes do frame de captura."
        );
      }
    });
  }

  loadVsoftConfigFile = (emissor: string) =>
    this.httpClient
      .get(
        `${tenantAssetsBase(emissor)}/vsoft.json`,
        {
          observe: "body",
          responseType: "text",
        }
      )
      .pipe(
        take(1),
        catchError((err) => {
          return this.httpClient.get(`unico/vsoft.json`, {
            observe: "body",
            responseType: "text",
          });
        })
      );

  private async prepareCamera(vsoftOptions: Options) {
    const { takePicture } = camera();

    const el: HTMLElement | null = document.getElementById("frame");

    await loadFaceDetectorModels();

    if (navigator.mediaDevices) {
      try {
        console.log(vsoftOptions);
        //OPTIONS E PRA MUDAR O ESTILO DA CAMERA
        const obj = await takePicture({
          element: el as HTMLElement,
          i18n: {
            noFacesDetected: "Nenhuma face detectada",
            multipleFacesDetected: "Multiplas faces detectadas",
            moveFaceLeft: "Mova o rosto para a esquerda",
            moveFaceRight: "Mova o rosto para a direita",
            moveFaceUp: "Mova o rosto para cima",
            moveFaceDown: "Mova o rosto para baixo",
            keepStill: "Mantenha o rosto parado",
            moveFaceForward: "Aproxime o rosto",
            moveFaceBack: "Afaste o rosto",
          },
          faceDetectionAdapter: faceDetectionAdapter,
          options: vsoftOptions,
        });
        //A seguinte regex remove os metadatas que vem antes do base64 Ex: data:image/jpeg;base64;
        const encodedBase64Image = obj.base64.replace(
          /^data:image\/(png|jpeg|jpg);base64,/,
          ""
        );
        //ENVIA A IMAGEM
        this.imageCapture.emit({ image: encodedBase64Image, appKey: "" });
      } catch (e) {
        this.cancel.emit();
      }
    }
  }
}
